import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const NavigationDocumentsIcon = (props: SvgIconProps) => {
    const fill = props.fill ?? 'none';

    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill={fill} sx={{ ...props.sx, fill }}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 21H6C4.895 21 4 20.105 4 19V9C4 7.895 4.895 7 6 7H14C15.105 7 16 7.895 16 9V19C16 20.105 15.105 21 14 21Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16 17H18C19.105 17 20 16.105 20 15V5C20 3.895 19.105 3 18 3H10C8.895 3 8 3.895 8 5V7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 12H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 16H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
};

export default NavigationDocumentsIcon;
